<template>
	<div class="cardlist">
		<div class="cardlist-title">
			<label>{{$t(category)}}</label>
		</div>
		<div class="cardlist-dropdown">
			<Select popper-class="selectdropdown"
        :filterable="search"
				:value= "selected"
				value-key="id"
			 	placeholder="Select"
				@change="updateOption" >
				<Option
          v-for="item in list"
          :key="item.id"
          :label="item.tlabel ? $t(item.tlabel) : (item.label || item.name)"
          :value="item" >
				</Option>
			</Select>
		</div>
	</div>
</template>

<script>
export default {
	props:{
    category: String,
    search: {
      default: false,
      type: Boolean,
    },
		list: Array,
		selected: {},
	},
	data() {
		return {
		}
	},
	methods: {
		updateOption(option) {
      this.$emit('updateOption', option, this.category);
    },
	},
};
</script>
